module.exports = __webpack_public_path__ + "img/lightfon.5ea10ba0.png";